import type { MasterRateApiItemInterface } from 'features/Enterprise/Payroll/types'
import type { MasterRateItemType } from 'features/Enterprise/Payroll/redux/masterRate'

export const parseEffectiveDate = (s: string): Date => {
  if (!s || s.length !== 8) return new Date()
  const y = parseInt(s.slice(0, 4), 10)
  const m = parseInt(s.slice(4, 6), 10) - 1
  const d = parseInt(s.slice(6, 8), 10)
  const date = new Date(y, m, d)
  return Number.isNaN(date.getTime()) ? new Date() : date
}

export const formatRoleLabel = (role: string): string => role.split('_').join(' ')

export const mapApiToRateItem = (item: MasterRateApiItemInterface): MasterRateItemType => ({
  id: item.id,
  role: item.role,
  basePay: item.base_pay,
  ho: item.ho,
  ho2: item.ho2,
  ot2_4: item.ot_2_4,
  ot_gt4: item.ot_4,
  halfDay: item.half_day,
  onleave: item.onleave,
  volunteer: item.volunteer,
  effectiveDate: item.effective_date,
  rateType: item.rate_type,
})
